import i18n from '@/modules/i18n/i18n'

export type Level = 'l1' | 'blockface' | 'cfad' | 'parking_districts' | null

export const CITYWIDE_LAYER_UUID = 'citywide'

export const getCitywideLayerName = () => i18n.t('common.citywideTitle', 'Citywide')

export interface LayerOption {
  text: string
  value: string
  level?: Level
}

export const getCitywideLayerOption = (): LayerOption => ({
  text: getCitywideLayerName(),
  value: CITYWIDE_LAYER_UUID,
  level: undefined,
})

/**
 * Add or remove the citywide option from a layer-options list depending on whether the policy
 * allows targeting the entire region. Pure (returns a new array); was `SpatialPolicy.shapeLayerOptions`.
 * Any pre-existing citywide entry is stripped first, so it never duplicates regardless of position.
 * An empty input stays empty even when the entire region is allowed (no layers => nothing to offer).
 */
export const applyCitywideOption = (
  options: LayerOption[],
  optionalEntireRegion: boolean
): LayerOption[] => {
  const withoutCitywide = options.filter(({ value }) => value !== CITYWIDE_LAYER_UUID)
  if (!optionalEntireRegion || !options.length) {
    return withoutCitywide
  }
  return [getCitywideLayerOption(), ...withoutCitywide]
}
